// extracted by mini-css-extract-plugin
export default {"content":"ModalEditarProfesor_content__mCTv6","intro":"ModalEditarProfesor_intro__huUQX","input":"ModalEditarProfesor_input__a2L7M","acceso":"ModalEditarProfesor_acceso__lY7go"};